import { htcmdService } from 'js/services/htcmd.service';
import { useAuthSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useEffect } from 'react';
import { usePrevious } from 'js/hooks/usePrevious';

export const useNativeLogoutTrigger = () => {
    const { isLogoutManual, isLogoutInProcess } = useAuthSelector(pick(['isLogoutManual', 'isLogoutInProcess']));
    const prevIsLogoutInProcess = usePrevious(isLogoutInProcess);

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            return;
        }

        if (!prevIsLogoutInProcess && isLogoutInProcess) {
            htcmdService.logout(isLogoutManual);
        }
    }, [
        isLogoutManual,
        isLogoutInProcess,
        prevIsLogoutInProcess
    ]);
};
